import Keycloak, { type KeycloakInitOptions } from 'keycloak-js'

import { SESSION_STORAGE_CHAVE_ROTA_POS_LOGIN } from '@/config/constantes'

export const ROTA_PADRAO_POS_LOGIN = '/app/documentos'
const KEYCLOAK_REDIRECT_LOGOUT_URI = `${window.location.origin}`

const ehRotaPosLoginValida = (rota: string | null): rota is string =>
  !!rota && rota.startsWith('/app/')

export const salvarRotaPosLogin = (
  rota = `${window.location.pathname}${window.location.search}`
): void => {
  if (!ehRotaPosLoginValida(rota)) return

  try {
    sessionStorage.setItem(SESSION_STORAGE_CHAVE_ROTA_POS_LOGIN, rota)
  } catch {}
}

export const obterRotaPosLogin = (): string | null => {
  try {
    const rota = sessionStorage.getItem(SESSION_STORAGE_CHAVE_ROTA_POS_LOGIN)
    return ehRotaPosLoginValida(rota) ? rota : null
  } catch {
    return null
  }
}

export const limparRotaPosLogin = (): void => {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_CHAVE_ROTA_POS_LOGIN)
  } catch {}
}

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_BASE_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
}

const keycloak = new Keycloak(keycloakConfig)

export const inicializarKeycloak = async (
  options: {
    onLoad?: 'check-sso' | 'login-required'
    checkLoginIframe?: boolean
    redirectUri?: string
  } = {}
): Promise<boolean> => {
  const defaultOptions = {
    onLoad: 'check-sso' as const,
    checkLoginIframe: false,
    redirectUri: window.location.href,
  } as KeycloakInitOptions

  const config = { ...defaultOptions, ...options }
  return keycloak.init(config)
}

export const login = async (): Promise<void> => {
  return keycloak.login({
    redirectUri: `${window.location.origin}${obterRotaPosLogin() ?? ROTA_PADRAO_POS_LOGIN}`,
  })
}

export const logout = async (urlDeRedirecionamento?: string): Promise<void> => {
  const urlFinal = urlDeRedirecionamento || KEYCLOAK_REDIRECT_LOGOUT_URI

  return keycloak.logout({
    redirectUri: urlFinal,
  })
}

export const atualizarToken = async (minValidity = 30): Promise<boolean> => {
  try {
    const refreshed = await keycloak.updateToken(minValidity)
    return refreshed
  } catch (error) {
    console.error('Erro ao atualizar token:', error)
    throw error
  }
}

export const configurarListenersKeycloak = (callbacks: {
  onAuthSuccess?: () => void
  onAuthLogout?: () => void
}): void => {
  if (callbacks.onAuthSuccess) {
    keycloak.onAuthSuccess = callbacks.onAuthSuccess
  }

  if (callbacks.onAuthLogout) {
    keycloak.onAuthLogout = callbacks.onAuthLogout
  }
}

export default keycloak
